import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const CreateOwnCriteriaPopup = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.createOwnCriteria}>
      <h2
        dangerouslySetInnerHTML={{__html: t("popup.create_own_criteria.subtitle")}}
      />
    </div>
  );
};
